import React from 'react'
import { Switch, Route } from 'react-router-dom'

import CreateClaim from 'Containers/CreateClaimContainer'
import Terms from 'Containers/AcceptTermsContainer'
import Claim from 'Containers/ClaimContainer'
import ClaimPdf from 'Containers/ClaimPdf/ClaimPdfContainer'
import { NavBar } from 'Components';
import { FormPageWrapper } from './Styles';

const ClaimLayout = ({ match }) => (
  <FormPageWrapper>
    <NavBar />
    <Switch>
      <Route exact path={match.path} component={CreateClaim} />
      <Route path={`${match.path}/:claimId/pdf`} component={ClaimPdf} />
      <Route path={`${match.path}/:claimId/survey`} component={Claim} />
      <Route path={`${match.path}/:claimId`} component={Terms} />
    </Switch>
  </FormPageWrapper>
)

export default ClaimLayout



// WEBPACK FOOTER //
// ./src/Layouts/ClaimLayout.jsx